/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Umbraco Delivery API
 * You can find out more about the Umbraco Delivery API in [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api).
 * OpenAPI spec version: Latest
 */

export type TwoOneColumnUmbBlockGridElementModelContentType =
	(typeof TwoOneColumnUmbBlockGridElementModelContentType)[keyof typeof TwoOneColumnUmbBlockGridElementModelContentType];

export const TwoOneColumnUmbBlockGridElementModelContentType = {
	twoOneColumnUmbBlockGrid: "twoOneColumnUmbBlockGrid",
} as const;
